import { render, staticRenderFns } from "./ShippingMethodUpdate.vue?vue&type=template&id=0f239339&"
import script from "./ShippingMethodUpdate.vue?vue&type=script&lang=ts&"
export * from "./ShippingMethodUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports